import React from 'react';
import styled from 'styled-components';
import { AnimatePresence, motion } from 'framer-motion';
import { SIZE_TRANSITION } from "./sheet-transitions";
/**
 * Animated wrapper for display sheet content. It should animate
 * whenever the id of the Sheet changes.
 */

export function SheetContent(_ref) {
  var children = _ref.children,
      size = _ref.size,
      id = _ref.id;
  return /*#__PURE__*/React.createElement(RelativeContainer, null, /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false
  }, /*#__PURE__*/React.createElement(StyledSheetContent, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    style: {
      width: "".concat(size, "px")
    },
    transition: SIZE_TRANSITION,
    key: id
  }, children)));
}
export var StyledSheetContent = styled(motion.div).withConfig({
  displayName: "SheetContent__StyledSheetContent",
  componentId: "vapor__fcxpyd-0"
})(["position:absolute;top:0;left:0;right:0;bottom:0;"]);
var RelativeContainer = styled.div.withConfig({
  displayName: "SheetContent__RelativeContainer",
  componentId: "vapor__fcxpyd-1"
})(["position:relative;flex:1;"]);